import { useCallback } from 'preact/hooks';

import { type ProductSelection, useCheckoutInterception } from './CheckoutHandlerContext';

/**
 * What to do with a Stripe checkout URL once the session exists.
 *
 * By default the page navigates to it. Inside the Speedy Flow that would tear down the modal and
 * lose the visitor's place — the entire point of the feature — so the flow provides a handler that
 * opens the URL in a tab and watches for the entitlement instead.
 *
 * Every product card must route its checkout through this. Four of them previously inlined
 * `window.location.href = data.url`, which silently opted them out of the flow.
 */
const useCheckoutRedirect = () => {
  const interception = useCheckoutInterception();

  return useCallback(
    (url: string, selection: ProductSelection) => {
      if (interception?.onCheckoutUrl) {
        interception.onCheckoutUrl(url, selection);
        return;
      }
      window.location.href = url;
    },
    [interception],
  );
};

export default useCheckoutRedirect;
